import { ApiCall } from '.';

/**
 * Saves key-value pair to profile settings
 * @param {object} settings
 * @param {Function} callback (iserror, data)
 */
export const SaveProfileSetting = (pca, settings, callback) => {
    ApiCall(pca, "Profiili", "Update", settings, null, callback)
};